const easeInOutSin = (time) => {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
};
export function animateElementByProp({ propToAnimate, element, moveTo, duration = 700, }) {
    const ease = easeInOutSin;
    const startPoint = element[propToAnimate];
    let start = null;
    let doneResolve;
    const done = new Promise((res) => {
        doneResolve = res;
    });
    let animationId = null;
    const cancel = () => {
        cancelAnimationFrame(animationId);
    };
    const updateBy = (newTarget) => {
        moveTo += newTarget;
    };
    const step = (timestamp) => {
        if (start === null) {
            start = timestamp;
        }
        const time = Math.min(1, (timestamp - start) / duration);
        element[propToAnimate] = startPoint + ease(time) * (moveTo - startPoint);
        if (time === 1) {
            start = null;
            doneResolve();
        }
        else {
            animationId = requestAnimationFrame(step);
        }
    };
    if (startPoint !== moveTo) {
        animationId = requestAnimationFrame(step);
    }
    return {
        cancel,
        updateBy,
        done,
    };
}
//# sourceMappingURL=animations.js.map